export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {},
  staticActions: {},

  schema: {
    create({ searchfield, userId }, data) {
      return {
        searchfield: searchfield, // e.g. email, username
        userId: userId,
      };
    },

    fields: {
      searchfield: { validate_bolt_type: 'String' },
      userId: { validate_bolt_type: 'UserID' },
    }
  }
};
